import React from 'react';
import './Table.css';

interface DataTableProps {
    columns: string[];
    data: Array<Record<string, any>>;
    rowsPerPage?: number;
    totalPages: number;
    currentPage: number;
    setCurrentPage: (page: number) => void;
    onRowClick?: (row: Record<string, any>) => void;
}

const Table: React.FC<DataTableProps> = ({
                                             columns,
                                             data,
                                             rowsPerPage = 10,
                                             totalPages,
                                             currentPage,
                                             setCurrentPage,
                                             onRowClick,
                                         }) => {
    const pages = totalPages;

    const handleNextPage = () => {
        if (currentPage < pages - 1) {
            setCurrentPage(currentPage + 1);
        }
    };

    const handlePreviousPage = () => {
        if (currentPage > 0) {
            setCurrentPage(currentPage - 1);
        }
    };

    const emptyRows = rowsPerPage - data.length;

    // Calculate column width based on the number of columns
    const columnWidth = `${100 / columns.length}%`;

    return (
        <div>
            <div className="table-wrapper">
                <table className="custom-table">
                    <thead>
                    <tr>
                        {columns.map((column, index) => (
                            <th
                                key={index}
                                style={{
                                    width: columnWidth,      // Apply calculated width
                                    maxWidth: columnWidth,   // Dynamically set maxWidth
                                    whiteSpace: 'nowrap',    // Prevent wrapping
                                    overflow: 'hidden',      // Hide overflow
                                    textOverflow: 'ellipsis' // Add ellipsis
                                }}
                            >
                                {column}
                            </th>
                        ))}
                    </tr>
                    </thead>
                    <tbody>
                    {data.map((row, rowIndex) => (
                        <tr
                            key={rowIndex}
                            onClick={() => onRowClick && onRowClick(row)}
                            style={{ cursor: onRowClick ? 'pointer' : 'default' }}
                        >
                            {columns.map((column, colIndex) => (
                                <td key={colIndex} style={{ width: columnWidth }}>
                                    {row[column]}
                                </td>
                            ))}
                        </tr>
                    ))}
                    {/* Render empty rows */}
                    {Array.from({ length: emptyRows }).map((_, rowIndex) => (
                        <tr key={`empty-${rowIndex}`}>
                            {columns.map((_, colIndex) => (
                                <td key={colIndex} style={{ width: columnWidth }}>&nbsp;</td>
                            ))}
                        </tr>
                    ))}
                    </tbody>
                </table>
            </div>
            {pages === 0 ? (
                <div></div>
            ) : (
                <div className="pagination-controls">
                    <button
                        onClick={handlePreviousPage}
                        disabled={currentPage === 0}
                        className="pagination-button"
                    >
                        Anterior
                    </button>
                    <span className="pagination-info">
                        Página {currentPage + 1} de {pages}
                    </span>
                    <button
                        onClick={handleNextPage}
                        disabled={currentPage === pages - 1}
                        className="pagination-button"
                    >
                        Siguiente
                    </button>
                </div>
            )}
        </div>
    );
};

export default Table;